export function setAll(state, { all }) {
  state.all = all;
}

export function setAllocations(state, { allocations }) {
  state.allocations = allocations;
}

export function setAllTransferCards(state, { transferCards }) {
  state.transferCards = transferCards;
}

export function setAllTransactions(state, { transactions }) {
  state.transactions = transactions;
}
